document.addEventListener('variant:change', function (evt) {
  var $variant = evt.detail.variant;
  if ($variant) {
    var $productEl = $.find(`.product-${$variant.featured_image.product_id}`);
    if ($productEl) {
      var $afterpay = $($productEl).find('.afterpay-message'),
        $zippay = $($productEl).find('.zip-message'),
        $rewards = $($productEl).find('.outdo-rewards');

      $rewards.find('.money').text('$' + ($variant.price / 5000).toFixed(2));
      $afterpay.find('.money').text('$' + ($variant.price / 400).toFixed(2));
      $zippay.find('.money').text('$' + ($variant.price / 400).toFixed(2));
    }
  }
});


document.addEventListener('ajaxProduct:added', function (evt) {
    var $cart = evt.detail.cart;
    document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
            cart: $cart
        }
    }))
});


document.addEventListener('cart:updated', function(evt) {
  var $subtotal = evt.detail.cart.total_price;
  if ($subtotal) {
    window.localStorage.setItem('outdo-subtotal', $subtotal);
    initShippingInfo($subtotal);
  }
});

function shippingRegionChange(regionObject, cartTotal) {
  var region = regionObject.value;
  window.localStorage.setItem('outdo-user-region', region);
  var subTotal = window.localStorage.getItem('outdo-subtotal');
  subTotal ??= cartTotal;
  initShippingInfo(subTotal);
}

function initShippingInfo(cartTotal) {
    var region = window.localStorage.getItem('outdo-user-region');
    region ??= 'auckland';

    $(".shipping-info-container .form-select").val(region);

    let auckland_free_shipping_threshold = 7500;
    let north_island_free_shipping_threshold = 10000;
    let south_island_free_shipping_threshold = 15000;
    var freeShippingDistance = 0;
    var freeShippingPercentage = 0;

    switch (region) {
        case 'auckland':
            freeShippingDistance = auckland_free_shipping_threshold - cartTotal;
            freeShippingPercentage = ((cartTotal / auckland_free_shipping_threshold) * 100).toFixed();
            break;
        case 'north-island':
            freeShippingDistance = north_island_free_shipping_threshold - cartTotal;
            freeShippingPercentage = ((cartTotal / north_island_free_shipping_threshold) * 100).toFixed();
            break;
        case 'south-island':
            freeShippingDistance = south_island_free_shipping_threshold - cartTotal;
            freeShippingPercentage = ((cartTotal / south_island_free_shipping_threshold) * 100).toFixed();
            break;
    }

    var $awayEl = $.find('.shipping-info-container .free_shipping_away_message');
    var $freeShippingEl = $.find('.shipping-info-container .free_shipping_message');
    var $progressBar = $.find(".shipping-info-container .progress-bar");
    var $progress = $.find(".shipping-info-container .progress");

    if (cartTotal !== 0) {
        if (freeShippingDistance > 0) {
            $($awayEl).show();
            $($awayEl).find('.amount').text((freeShippingDistance / 100).toFixed(2));
            $($freeShippingEl).hide();
            $($progress).show();
            $($progressBar).width(`${freeShippingPercentage}%`);
        } else {
            $($awayEl).hide();
            $($freeShippingEl).show();
            $($progress).show();
            $($progressBar).width("100%");
        }
    } else {
        $($awayEl).hide();
        $($freeShippingEl).hide();
        $($progress).hide();
    }
};